import { BalanceAction } from "../Balance.types";

export const ACTION_LABEL: Record<BalanceAction, string> = {
    add: "+",
    display: "",
    round: "≈ ",
    less: "< ",
};
